import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "b-profile-contact" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwSpinLoader = _resolveComponent("FwSpinLoader")!
  const _component_EditWorkerForm = _resolveComponent("EditWorkerForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_FwSpinLoader, {
          key: 0,
          colors: ["#27dbbd", "#27DBBD", "#27DBBD"],
          class: "h-flex-center loader",
          isActive: _ctx.loading,
          className: "h-p-20"
        }, null, 8, ["isActive"]))
      : _createCommentVNode("", true),
    (_ctx.workerData && !_ctx.loading)
      ? (_openBlock(), _createBlock(_component_EditWorkerForm, {
          key: 1,
          worker: _ctx.workerData,
          disabledForm: false,
          submitText: _ctx.$t(`BUTTON.SAVE`),
          onOnSubmit: _ctx.sendDataToServer
        }, null, 8, ["worker", "submitText", "onOnSubmit"]))
      : _createCommentVNode("", true)
  ]))
}